// Public, unauthenticated view for a week-plan share link (see
// the plan share sheet's link, components/plan/PlanShareSheet.tsx, and
// supabase/migrations/0020_week_plan_share_links.sql). Same shape as
// SharedRecipePage.jsx for the same reason: a signed-out visitor has none
// of the app session state (household, editing, the share panel itself)
// that PlanPage.jsx assumes, so this is its own small read-only renderer
// rather than a variant of it. Only ever shows recipe titles, never full
// ingredients/instructions -- see 0020's comment on why a plan link can't
// be used to route around a recipe's own sharing settings.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { COLORS, FONT_SIZE, SPACE, RADIUS } from "../lib/constants";
import { getWeekPlanByShareToken } from "../lib/db";
import { WeekPlanPreview } from "../components/WeekPlanPreview";

export function SharedWeekPlanPage() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, plan: null, error: false });
  const { paper, card, ink, soft, line } = COLORS;

  useEffect(() => {
    let cancelled = false;
    getWeekPlanByShareToken(token)
      .then((plan) => {
        if (!cancelled) setState({ loading: false, plan, error: false });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, plan: null, error: true });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  const wrapperStyle = { background: paper, color: ink, fontFamily: "var(--font-serif)", minHeight: "100vh", padding: SPACE.x4, boxSizing: "border-box" };

  if (state.loading) {
    return (
      <div style={{ ...wrapperStyle, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: soft }}>Loading plan…</span>
      </div>
    );
  }

  if (state.error || !state.plan) {
    return (
      <div style={{ ...wrapperStyle, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: soft }}>This link isn't valid — it may have been revoked.</span>
      </div>
    );
  }

  return (
    <div style={wrapperStyle}>
      <div style={{ maxWidth: 900, margin: "0 auto", background: card, border: `1px solid ${line}`, borderRadius: RADIUS.xxl, padding: SPACE.x4 }}>
        <div className="mp-sans" style={{ fontSize: FONT_SIZE.xs, color: soft, marginBottom: SPACE.lg }}>
          Shared from The Weekly Kitchen
        </div>
        <WeekPlanPreview plan={state.plan} colors={COLORS} />
      </div>
    </div>
  );
}
